import { Modal, Form, Select, Alert, InputNumber } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import toClass from 'recompose/toClass'

const FormItem = Form.Item
const SelectOption = Select.Option

function TransactionComponent(props) {
  const { form, record, plans, loading, ...rest } = props
  const { getFieldDecorator } = form

  return (
    <Modal
      centered
      title="Add or remove credits from account wallet"
      okText="Finish Transaction"
      okButtonProps={{ loading: props.loading }}
      {...rest}>
      <Form layout="vertical">
        <FormItem label="Operation" hasFeedback>
          {getFieldDecorator('operation', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <Select placeholder="Select an operation">
              <SelectOption key='credit'>Credit</SelectOption>
              <SelectOption key='debit'>Debit</SelectOption>
            </Select>
          )}
        </FormItem>
        <FormItem label="Amount" hasFeedback>
          {getFieldDecorator('amount', {
            rules: [
              {
                required: true,
              },
            ],
          })(
            <InputNumber min={0.01} step={0.01} />
          )}
        </FormItem>
      </Form>
      <Alert
        message="Careful!"
        description="If this account is set as payment account for any chatbot that has features that require credit, they might be affected by this action!"
        type="warning"
        showIcon
      />
    </Modal>
  )
}

export const TransactionModal = Form.create({
  mapPropsToFields: ({ record }) => Object.keys(record).reduce((xs, x) => ({ ...xs, [x]: Form.createFormField({ value: record[x] }) }), {}),
})(toClass(TransactionComponent))

TransactionComponent.propTypes = {
  record: PropTypes.object,
  form: PropTypes.any,
  loading: PropTypes.bool,
  plans: PropTypes.array,
}
